import { styled } from 'styled-components';

import { transition } from 'theme/theme';
import { getRgbaString } from 'utils/style';

export const EditOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  width: 100%;
  height: 100%;
  z-index: 2;
  align-items: center;
  justify-content: center;
  opacity: 0;
  background: rgba(${getRgbaString('black', 0.5)});
  transition: all ${transition};

  &:hover {
    opacity: 1;
  }

  * {
    position: relative;
  }
`;
